import React from "react";
import {
  FeatureStatisticSection,
  StatisticFeatureCard,
} from "@/.storyblok/types/319751/storyblok-components";
import { SbBlokData, storyblokEditable } from "@storyblok/react";
import { renderRichText } from "@/lib/richText";

interface FeatureStatisticSectionProps {
  blok?: FeatureStatisticSection & SbBlokData;
}

const StatisticFeatureCardComponent: React.FC<{
  blok: StatisticFeatureCard & SbBlokData;
}> = ({ blok }) => {
  return (
    <div
      className="statistics-row text-center mb-4"
      {...storyblokEditable(blok)}
    >
      <div className="statistic-number brand-dark-text">
        <span dangerouslySetInnerHTML={{ __html: blok.number || "" }} />
        <p className="lead">{blok.title}</p>
      </div>
    </div>
  );
};

const FeatureStatisticSectionComponent: React.FC<FeatureStatisticSectionProps> = ({
  blok,
}) => {
  if (!blok) return null;

  const { title, description, statistics, use_bottom_line } = blok || {};

  return (
    <>
      <div {...storyblokEditable(blok)} className="container py-4 py-md-5">
        <div className="row justify-content-xl-center gy-3 gy-md-0">
          <div className="col-md offset-xl-1 col-xxl-12">
            {title && <h2>{title}</h2>}
            {description && (
              <div
                className="mb-4"
                dangerouslySetInnerHTML={{
                  __html: renderRichText(description),
                }}
              />
            )}
          </div>
          <div className="col-md-auto offset-xl-2">
            {statistics?.map((stat) => (
              <StatisticFeatureCardComponent key={stat._uid} blok={stat as StatisticFeatureCard & SbBlokData} />
            ))}
          </div>
        </div>
      </div>
      {use_bottom_line && <hr />}
    </>
  );
};

export default FeatureStatisticSectionComponent;
